"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.On = exports.Off = void 0;

var _react = _interopRequireDefault(require("react"));

var _provider = require("../provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var On = function On(_ref) {
  var children = _ref.children;
  return children;
};

exports.On = On;

var Off = function Off(_ref2) {
  var children = _ref2.children;
  return children;
};

exports.Off = Off;

var ReleaseFlag = function ReleaseFlag(_ref3) {
  var id = _ref3.id,
      children = _ref3.children;
  var experiences = (0, _provider.useExperiences)();

  if (!experiences) {
    // eslint-disable-next-line no-console
    console.error('You have tried to use the Release component without first adding ExperienceProvider context - Please use react-chansey/provider component within your application first.');
    return null;
  }

  var experience = experiences[id];
  var childTypeName = experience !== null && experience !== void 0 && experience.value ? On.name : Off.name;
  return _react["default"].Children.toArray(children).find(function (child) {
    return child.type.name === childTypeName;
  });
};

var _default = ReleaseFlag;
exports["default"] = _default;